export default __webpack_public_path__ + "static/media/MATHEMATICS_REMIX.0e4b50d1.svg";